/**
 * Галерея: фільтр за категорією + лайтбокс.
 *
 * Лайтбокс — власний, без бібліотек: потрібні лише показ повного фото,
 * стрілки й закриття. Тягнути заради цього кілька десятків КБ — зайве.
 */
export default function gallery() {
	const grid = document.querySelector('.masonry');
	const lightbox = document.querySelector('.lightbox');
	if (!grid || !lightbox) return;

	// Лайтбокс position:fixed рахувався від трансформованого предка (галерея
	// у constrained-контейнері з will-change/transform), тому чорний фон був
	// не на весь екран, а ~924px. Виносимо в <body> — фон стає на весь viewport.
	document.body.appendChild(lightbox);

	const items = Array.from(grid.querySelectorAll('.masonry__item'));
	const chips = document.querySelectorAll('.filterbar--gallery .chip[data-cat]');

	const image = lightbox.querySelector('img');
	const btnClose = lightbox.querySelector('.lightbox__close');
	const btnPrev = lightbox.querySelector('.lightbox__nav--prev');
	const btnNext = lightbox.querySelector('.lightbox__nav--next');

	// Індекс поточного фото — рахуємо серед ВИДИМИХ, щоб стрілки гортали
	// в межах обраної категорії, а не по всій галереї.
	let visible = [];
	let current = 0;

	const refreshVisible = () => {
		visible = items.filter((item) => !item.hidden);
	};

	// ── Фільтр ─────────────────────────────────────────────────────────
	const applyFilter = (cat) => {
		items.forEach((item) => {
			item.hidden = cat !== 'all' && item.dataset.cat !== cat;
		});
		refreshVisible();
	};

	chips.forEach((chip) => {
		chip.addEventListener('click', () => {
			chips.forEach((c) => c.setAttribute('aria-pressed', 'false'));
			chip.setAttribute('aria-pressed', 'true');
			applyFilter(chip.dataset.cat);
		});
	});

	// ── Лайтбокс ───────────────────────────────────────────────────────
	const show = (index) => {
		if (!visible.length) return;

		// Циклічно: після останнього — знову перше.
		current = (index + visible.length) % visible.length;

		const btn = visible[current].querySelector('.masonry__zoom');
		const img = btn.querySelector('img');

		image.src = btn.dataset.full;
		image.alt = img.alt || '';
	};

	const open = (index) => {
		refreshVisible();
		show(index);
		lightbox.hidden = false;
		// Блокуємо скрол фону, поки лайтбокс відкритий (той самий підхід,
		// що й у мобільного меню — клас на <html>, не inline-стиль).
		document.documentElement.classList.add('is-nav-locked');
		btnClose.focus();
	};

	const close = () => {
		lightbox.hidden = true;
		document.documentElement.classList.remove('is-nav-locked');
		image.src = '';
	};

	grid.addEventListener('click', (e) => {
		const btn = e.target.closest('.masonry__zoom');
		if (!btn) return;

		refreshVisible();
		const index = visible.indexOf(btn.closest('.masonry__item'));
		open(index === -1 ? 0 : index);
	});

	btnClose.addEventListener('click', close);
	btnPrev.addEventListener('click', () => show(current - 1));
	btnNext.addEventListener('click', () => show(current + 1));

	// Клік по тлу (але не по самому фото) — закриває.
	lightbox.addEventListener('click', (e) => {
		if (e.target === lightbox) close();
	});

	document.addEventListener('keydown', (e) => {
		if (lightbox.hidden) return;

		if (e.key === 'Escape') close();
		if (e.key === 'ArrowLeft') show(current - 1);
		if (e.key === 'ArrowRight') show(current + 1);
	});

	refreshVisible();
}
